import React from "react";
import "./TooltipAction.css";

const TooltipAction = ({ message, visible, style = {} }) => {
  if (!visible) return null;

  return (
    <div className="tooltip-action-container" style={style}>
      <div className="tooltip-action-arrow" />
      <div className="tooltip-action-box">
        {message}
      </div>
    </div>
  );
};

export default TooltipAction;
